import XButton from '../common/XButton';
import Dialog from '../ui-control/Dialog';

const approveIconClasses = 'fa-solid fa-circle-check text-base';
const dialogPromptRowClasses = 'flex justify-center mt-8 px-4 text-center';
const dialogActionsRowClasses = 'flex justify-center mt-8';
const overlayClasses = 'fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-black/40';
const overlaySpinnerClasses = 'animate-spin h-10 w-10 border-[0.25em] border-white border-t-transparent rounded-full';
const overlayTextClasses = 'text-white font-semibold';

const LifecareStudioApproveButton = ({
  isApproving,
  isApproveDisabled,
  isReplaceModalOpen,
  requestApprove,
  confirmApprove,
  cancelApprove,
}) => (
  <>
    <XButton onClick={requestApprove} disabled={isApproveDisabled} loading={isApproving} loadingText="Approving...">
      <i className={approveIconClasses} aria-hidden="true" />
      Approve
    </XButton>

    <Dialog
      isModalOpen={isReplaceModalOpen}
      onToggleDialog={(isOpen) => { if (!isOpen) cancelApprove(); }}
      mode="small-half"
    >
      <div className={dialogPromptRowClasses}>
        <h3>Replace the existing Lifecare Plan file for this plaintiff?</h3>
      </div>
      <div className={dialogActionsRowClasses}>
        <XButton onClick={confirmApprove} className="min-w-24!">Replace</XButton>
        <XButton variant="outlinePrimary" onClick={cancelApprove} className="ml-4! min-w-24!">Cancel</XButton>
      </div>
    </Dialog>

    {isApproving && (
      <div className={overlayClasses} role="status" aria-live="assertive">
        <div className={overlaySpinnerClasses} />
        <span className={overlayTextClasses}>Approving Life Care Plan...</span>
      </div>
    )}
  </>
);

export default LifecareStudioApproveButton;
